// extracted by mini-css-extract-plugin
export var alignCenter = "_az-d";
export var bannerShown = "_az-6";
export var buttonContent = "_az-0";
export var cardList = "_az-1";
export var centerContent = "_az-2";
export var chevron = "_az-3";
export var closePanelButton = "_az-k";
export var conversationContextContainer = "_az-l";
export var conversationDetailContainer = "_az-4";
export var detailWrapper = "_az-7";
export var dropdownButton = "_az-e";
export var dropdownTitle = "_az-9";
export var fullHeight = "_az-5";
export var hidden = "_az-a";
export var icon = "_az-b";
export var mergeSuggestionWrapper = "_az-m";
export var panel = "_az-i";
export var portalButtonsWrapper = "_az-c";
export var right = "_az-j";
export var tableSummaryContainer = "_az-8";
export var tableSummaryHeader = "_az-g";
export var threeDotsButton = "_az-f";
export var wide = "_az-h";